import Data from './data'

export default {
    loops: () => [200, Data.loops],
    model: () => [200, Data.model],
    modelInfo: () => [200, Data.modelInfo],
    dashboard: () => [200, Data.dashboard],
}
